// extracted by mini-css-extract-plugin
export var divider = "_s6-0";
export var systemMessage = "_s6-1";